<div class="card card-no-border mt-3" style="height: fit-content;">
    <div class="card-body">
        <div class="row col-12">
            <!-- Search Field -->
            <div class="col-6">
                <div style="max-width: 500px;">
                    <div class="input-group">
                        <span class="input-group-text">
                            <i class="fa-light fa-magnifying-glass"></i>
                        </span>
                        <input type="search" class="form-control" placeholder="Søg efter konsulenter eller ressourcer"
                            aria-label="Search" autocomplete="off" autofocus [(ngModel)]="searchText">
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="card h-80 card-no-border mt-2">
        <div class="card-body position-relative">
            <!-- Header -->
            <div class="flex-row d-flex justify-content-between align-items-center">
                <ul class="nav nav-pills nav-fill gap-1" style="width: 800px;">
                    <li class="nav-item">
                        <button class="nav-link" [ngClass]="{'active': category === 'external'}"
                            (click)="category = 'external'">
                            Indlånte konsulenter <i class="fa-light fa-circle-question info-icon"
                                title="Få overblik over hvilke konsulenter er indlånt, og fra hvilken afdeling. &#13;De vil have adgang til data fra deres tildelte kunde."></i>
                        </button>
                    </li>
                    <li class="nav-item">
                        <button class="nav-link" [ngClass]="{'active': category === 'admin'}"
                            (click)="category = 'admin'">
                            Crono administrator <i class="fa-light fa-circle-question info-icon"
                                title="Se overblik over hvilke konsulenter har administrator ressourcer. &#13;Opret administrator ressourcer for konsulenter."></i>
                        </button>
                    </li>
                </ul>
            </div>

            <!-- External resources table -->
            @if(category === 'external') {
            <div class="d-flex flex-wrap mt-1">
                <div class="d-flex gap-2 ms-auto">
                    <div class="text-end">
                        <button class="btn btn-primary" (click)="showUserAccess()"
                            alt="Tilføj en konsulent som får adgang til afdelings Crono kunder."><i class="fa-solid fa-user-lock me-2"></i>Tilføj
                            konsulentadgang</button>
                    </div>
                </div>
            </div>

            <div class="table-wrap-60vh">

                @if(isLoadingExternal()) {
                <div class="d-flex flex-column justify-content-center align-items-center w-100 h-100">
                    <div class="continuous-loader" role="status"></div>
                    <h4 class="mt-2">Indlæser konsulenter</h4>
                </div>
                } @else {

                <table class="table table-striped mb-0">

                    @if(filteredExternalResources().length == 0)
                    {
                    <thead>
                        <tr>
                            <th class="ms-2 no-data">Ingen konsulenter at vise.</th>
                        </tr>
                    </thead>
                    }
                    @else
                    {
                    <thead class="thead-sticky">
                        <tr>
                            <th>Navn</th>
                            <th style="width: 200px;">Afdeling</th>
                            <th style="width: 100px;"></th>
                        </tr>
                    </thead>
                    }

                    <tbody>
                        <!-- For Each Resource -->
                        @for (resource of filteredExternalResources(); track $index)
                        {
                        <tr (click)="ToggleResourceExternal(resource)">
                            <td>
                                {{resource.consultantName}}
                            </td>
                            <td>
                                {{resource.department}}
                            </td>
                            <td>
                                @if (resource.role != 4) {
                                <div class="text-center"><i
                                        [class]="resource.showCustomers ? 'fa-solid fa-chevron-down' : 'fa-solid fa-chevron-right'"></i>
                                </div>
                                }
                                @else {
                                <div class="text-center">
                                    <button class="btn btn text-center" title="Slet ressource"
                                        (click)="deleteAccessForConsultant(resource)">
                                        <i class="text-danger fa-regular fa-trash-can"></i>
                                    </button>
                                </div>
                                }
                            </td>
                        </tr>
                        <tr hidden></tr> <!-- Hidden row to keep the table structure -->
                        <tr [hidden]="!resource.showCustomers">
                            @if (resource.loadingCustomers) {
                            <td colspan="5">
                                Henter Kunder...
                            </td>
                            }@else if (resource.customers.length == 0) {
                            <td colspan="5">
                                Ingen kunder tilknyttet
                            </td>

                            } @else {

                            <td colspan="5">
                                <table class="table mb-3 nested-table">
                                    <thead>
                                        <th>Kunde</th>
                                        <th style="width: 150px;">Dato</th>
                                        <th style="width: 282px;">Rolle</th>
                                        <!-- 282px puts it in line with outer header -->
                                    </thead>
                                    <tbody>
                                        @for (customer of resource.customers; track $index)
                                        {
                                        <tr (click)="navigateToCustomerDashboard(customer.customerId)"
                                            title="Naviger til kunde">
                                            <td>{{customer.customerName}}</td>
                                            <td>{{customer.assigned | date:'dd-MM-yyyy' }}</td>
                                            <td>{{customer.role}}</td>
                                        </tr>
                                        }
                                    </tbody>
                                </table>
                            </td>
                            }
                        </tr>
                        }
                    </tbody>
                </table>
                }

            </div>
            <div class="row">
                <div class="col d-flex gap-2 mt-1">
                    <div>
                        <h5 style="margin-top: 1px;">Configtool admins <i class="fa-light fa-circle-question info-icon"
                                title="Disse afdelinger har administrator rettigheder. &#13;De vil have adgang til alle afdelinger."></i>
                            :</h5>
                    </div>
                    <div class="col d-flex flex-wrap gap-2 mt-1">
                        @for (department of adminDepartments(); track $index) {
                        <div title="{{GetAdminDepartmentTitle(department)}}" class="department-badge">
                            {{department.departmentCode}}
                        </div>
                        }
                    </div>

                </div>
            </div>
            }
            @else if(category === 'admin') {
            <!-- Admin resources table -->
            <div class="d-flex flex-wrap mt-1 justify-content-between">
                <!-- Left side: Show Mine and Show All -->
                <div class="d-flex gap-2 align-items-center">
                    <!-- Show Mine button -->
                    <button class="btn btn-outline-secondary" (click)="showMyResources()" title="Vis kun mine ressourcer">
                        <i class="fa-light fa-user"></i> Vis mine egne
                    </button>
                    
                    <!-- Show All toggle (only for admins) -->
                    @if(category === 'admin' && store.currentUser.get().isAdmin) {
                    <div class="form-check form-switch">
                        <input class="form-check-input" type="checkbox" id="showAll" [ngModel]="showAll()"
                            (ngModelChange)="showAll.set($event)">
                        <label class="form-check-label text-nowrap" for="showAll">
                            Vis Alle
                        </label>
                    </div>
                    }
                </div>
                
                <!-- Right side: Create Admin Dropdown -->
                <div class="d-flex align-items-center">
                    <div class="dropdown">
                        <button class="btn btn-primary dropdown-toggle" type="button" 
                                data-bs-toggle="dropdown" aria-expanded="false"
                                [disabled]="addingAdmin()" style="min-width: 300px;">
                            @if(addingAdmin()) {
                            <i class="fas fa-lg fa-spinner fa-spin me-2"></i>
                            Opretter administrator adgang...
                            } @else {
                            <i class="fa fa-user-tie me-2"></i>
                            Opret som administrator for alle afdelingens kunder
                            }
                        </button>
                        <ul class="dropdown-menu" style="min-width: 300px; max-height: 300px; overflow-y: auto;">
                            @if(departmentResources().length === 0) {
                            <li><span class="dropdown-item-text">Ingen ressourcer tilgængelige</span></li>
                            } @else {
                            @for (resource of departmentResources(); track $index) {
                            <li>
                                <a class="dropdown-item resource-item" href="#" 
                                   (click)="onCreateAdminResourceSelect(resource.resourceGuid); $event.preventDefault()">
                                    <i class="fa fa-user me-2 resource-icon"></i>
                                    {{resource.resourceName}}
                                </a>
                            </li>
                            }
                            }
                        </ul>
                    </div>
                </div>
            </div>
            <div class="table-wrap-60vh">
                @if(isLoadingAdmin()) {
                <div class="d-flex flex-column justify-content-center align-items-center w-100 h-100">
                    <div class="continuous-loader" role="status"></div>
                    <h4 class="mt-2">Indlæser konsulenter</h4>
                </div>

                } @else {

                <table class="table table-striped mb-0 sortable">
                    @if(filteredAdminResources().length == 0)
                    {
                    <thead>
                        <tr>
                            <th class="ms-2 no-data">Ingen konsulenter at vise.</th>
                        </tr>
                    </thead>
                    }
                    @else
                    {
                    <thead class="thead-sticky">
                        <tr>
                            <th style="width: 120px; cursor: pointer;" (click)="sortTable('assigned')">Oprettet d.
                                @if(sortBy() === 'assigned') {
                                <i
                                    [class]="sortDirection() === 'asc' ? 'fa-solid fa-chevron-up' : 'fa-solid fa-chevron-down'"></i>
                                }
                            </th>
                            <th class="text-end" style="width: 120px; cursor: pointer;" (click)="sortTable('customerId')">Kunde Id
                                @if(sortBy() === 'customerId') {
                                <i
                                    [class]="sortDirection() === 'asc' ? 'fa-solid fa-chevron-up' : 'fa-solid fa-chevron-down'"></i>
                                }
                            </th>
                            <th style="width: 300px; cursor: pointer;" (click)="sortTable('customerName')">Kunde navn
                                @if(sortBy() === 'customerName') {
                                <i
                                    [class]="sortDirection() === 'asc' ? 'fa-solid fa-chevron-up' : 'fa-solid fa-chevron-down'"></i>
                                }
                            </th>
                            <th style="cursor: pointer;" (click)="sortTable('resourceName')">Konsulentnavn
                                @if(sortBy() === 'resourceName') {
                                <i
                                    [class]="sortDirection() === 'asc' ? 'fa-solid fa-chevron-up' : 'fa-solid fa-chevron-down'"></i>
                                }
                            </th>
                            <th>Initialer</th>
                            <th>Klikadgangskode</th>
                            @if(showAll()) {
                            <th>Afdeling</th>
                            }
                            <th style="width: 100px;">

                            </th>
                        </tr>
                    </thead>
                    }

                    <tbody>
                        <!-- For Each Resource -->
                        @for (resource of filteredAdminResources(); track `${resource.resourceGuid}-${resource.customerId}`)
                        {
                        <tr>
                            <td>{{resource.assigned | date:'dd-MM-yyyy' }}</td>
                            <td class="text-end">
                                <a [routerLink]="['/customer-dashboard', resource.customerId]" class="no-underline">
                                    ({{resource.customerId}})
                                </a>
                            </td>
                            <td>
                                <a [routerLink]="['/customer-dashboard', resource.customerId]" class="no-underline">
                                    {{resource.customerName}}
                                </a>
                            </td>
                            <td>{{resource.resourceName}}</td>
                            <td>{{resource.initials}}</td>
                            <td>{{resource.temporaryPassword}}</td>
                            @if(showAll()) {
                            <td>{{resource.departmentName}}</td>
                            }
                            <td>
                                <div class="d-flex gap-2">
                                    <button class="btn btn-primary btn-sm" title="Nulstil adgangskode"
                                        (click)="resetPassword(resource)">
                                        <i class="fa-solid fa-xs fa-rotate-left me-1"> </i>
                                        <i class="fa-light fa-lock"></i>
                                    </button>
                                    <button class="btn btn-danger btn-sm" title="Slet ressource"
                                        (click)="deleteResource(resource)">
                                        <i class="fa fa-trash"></i>
                                    </button>
                                </div>
                            </td>
                        </tr>
                        }
                    </tbody>
                </table>
                }
            </div>
            <div class="d-flex gap-2 mt-1">
                <div>
                    <h5 class="text-nowrap" style="margin-top: 1px;">Crono administratorer <i
                            class="fa-light fa-circle-question info-icon"
                            title="Disse afdelinger vil altid blive oprettet som Crono administrator for en kunde."></i>
                        :</h5>
                </div>
                <div class="d-flex gap-2">
                    @if (adminDepartments().length != 0) {
                    @let department = adminDepartments()[0];
                    <div title="{{GetAdminDepartmentTitle(department)}}" class="department-badge">
                        {{department.departmentCode}}
                    </div>
                    }
                </div>
            </div>
            }

        </div>
    </div>